// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lVE4","content":"styles_content__1Y7ZG","row":"styles_row__1-QxU","footer":"styles_footer__1jPQj","phraseLength":"styles_phraseLength__1QN58"};